import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal, Button, Input } from '../components'
import { http } from '../http'

const initialFormValues = {
  id: ''
}

export const DeviceUnlinkRoute = () => {
  const navigate = useNavigate()
  const [formValues, setFormValues] = useState(initialFormValues)

  return (
    <Modal heading="Unlink" onClose={() => navigate('/devices')}>
      <div className="mt-4 mb-8">
        <Input
          label="Device ID"
          type="text"
          onChange={fieldValue => handleChange('id', fieldValue)}
        />
      </div>
      <Button.Group>
        <Button.Outlined onClick={() => navigate('/devices')} text="Cancel"/>
        <Button.Primary onClick={handleCommit} text="Submit"/>
      </Button.Group>
    </Modal>
  )

  function handleChange(name, value) {
    setFormValues(prev => ({ ...prev, [name]: value }))
  }

  function handleCommit() {
    if ('' === formValues.id) {
      return
    }

    http.fetch('/crm.device.unlink', formValues).then(() => {
      navigate('/devices')
    })
  }
}